import React, { Fragment } from 'react';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { Link } from 'site-modules/shared/components/link/link';
import { getRankingsContentPath } from 'site-modules/shared/utils/upper-funnel/content-path';
import { bindToContent, CmsEntities } from 'client/data/models/cms';

import './make-type-list.scss';

function MakeTypeListUI({ browseByContent }) {
  if (!browseByContent) {
    return null;
  }
  const heading = browseByContent.metadata('title').value();
  const makesLinks = browseByContent.links();

  return (
    <Fragment>
      <h2 id="make-type-heading" className="heading-3 mb-1_5">
        {heading}
      </h2>
      <ul className="make-type-list list-unstyled" style={{ columns: '3' }} aria-labelledby="make-type-heading">
        {makesLinks.map(({ href, title }) => (
          <li key={title} className="make-type mb-1_5">
            <Link to={href} className="make-type-link" data-tracking-id="make_type_select">
              {title}
            </Link>
          </li>
        ))}
      </ul>
    </Fragment>
  );
}

MakeTypeListUI.propTypes = {
  browseByContent: CmsEntities.Content,
};

MakeTypeListUI.defaultProps = {
  browseByContent: null,
};

const stateToPropsConfig = {
  browseByContent: bindToContent(({ type }) => getRankingsContentPath(type), 'browse-by-brand'),
};

export const MakeTypeList = connectToModel(MakeTypeListUI, stateToPropsConfig);
